import { render } from "./ManageOrder.vue?vue&type=template&id=0a1f068c&scoped=true"
import script from "./ManageOrder.vue?vue&type=script&lang=js"
export * from "./ManageOrder.vue?vue&type=script&lang=js"

import "./ManageOrder.vue?vue&type=style&index=0&id=0a1f068c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1f068c"]])

export default __exports__